import React from "react";
import "./styles.scss";
import { Text } from "atoms";
import { FeatureItem } from "molecules";

export default props => (
  <div className="strict-grid">
    <Text h2 text={props.title}/>
    <div className="grid-container">
      <div className="column">
        { (props.elements || []).map( element => {
          return <FeatureItem key={element.title}
                              icon={element.icon} 
                              title={element.title} 
                              description={element.description}/>
        }) }
      </div>
      <img src={props.image} alt={props.imageAlt}/>
    </div>
  </div>
);
